import { Modal, Form, Spin, Tooltip } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { setResumeData } from 'modules/Onboarding/actions'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'
import {
  AdjustIcon,
  FooterFlex,
  LocalDiv,
  OptionWrapper,
  SelectLocalWrapper,
  Text,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import EducationForm from 'modules/Onboarding/Register/Education/EducationFormPartial'
import { educationDetails } from 'modules/Resume/DrawerComponents/constant'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import { getAppliedRoleMetrics } from '../../../Applied_Roles/actions'
import { updateCurrentState } from '../../../Onboarding/actions'
import { getStudentData } from '../../actions'
import instituteRequest from 'utils/instituteRequest'
import CrossIconSkill from 'components/icons/CrossIconSkill'
import { StyledDiv } from 'modules/Dashboard/Style/style'
import { SpinWrapper } from 'modules/Onboarding/Register/Education/style'
import { ModalTitle, FlexWrapRole } from 'modules/Roles/Style/style'
import {
  educationDetailsBefore,
} from 'modules/Onboarding/Register/EducationNew/constant'

const EducationalModal = ({
  modalVisible,
  setModalVisible,
  studentFormData,
  pendingData,
  updateStudentData,
  getPendingData,
  instituteName,
  deleteEducation,
  deleteFile,
  countryList,
  stateList,
  getListOfCountries,
  getListOfCity,
  getListOfState,
  getListOfSkills,
  degreeList,
  listOfStudentSkills,
  searchAPI,
  setRoleDrawer,
  itemId,
  setLoading,
  roleDrawer = false,
  getEligibleDetails,
  getRoleFloatDetails,
  setExpDrawer,
  expDrawer,
  setEduModalVisible,
  eduModalVisible
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const formRef = React.createRef()
  const [refreshKey, setRefreshKey] = useState(1)
  const { Option } = SelectLocalWrapper
  const [education, setEducation] = useState([])
  const [updated, setUpdated] = useState(false)
  const [stateId, setStateId] = useState('')
  const [cityId, setCityId] = useState('')
  const [locationData, setLocationData] = useState({
    stateId: '',
    state: '',
    cityId: '',
    city: '',
  })
  const [universityName, setUniversityName] = useState('')
  const [universitySearchList, setUniversitySearchList] = useState([])
  const [loading, setLocalLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [educationList, setEducationList] = useState([])
  const [countryId, setCountryId] = useState('')
  const [examType, setExamType] = useState('')
  const [duration, setDuration] = useState('')
  const [instituteCampusName, setInstituteCampusName] = useState('')
  const [universityId, setUniversityId] = useState('')
  const [instituteId, setInstituteId] = useState('')
  const [currentInstituteId, setCurrentInstituteId] = useState(
    studentFormData?.student?.instituteCampusId
      ? studentFormData?.student?.instituteCampusId
      : null
  )
  const [currentInstituteName, setCurrentInstituteName] = useState(
    studentFormData?.student?.instituteCampusName
      ? studentFormData?.student?.instituteCampusName
      : ''
  )
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)
  const [searchCollege, setSearchCollege] = useState('')
  const [skillLoading, setSkillLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [shown, setShown] = useState([])
  const [allSkills, setAllSkills] = useState([])
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])

  const universityList = useSelector(
    state => state?.studentData?.universityList
  )
  const AllCollegeList = useSelector(state => state?.resumeData?.AllCollegeList)
  const CollegeList = useSelector(state => state?.resumeData?.CollegeList)

  const getEducationLevelLabel = level => {
    switch (level) {
      case 'tenth':
        return '10th'
      case 'twelfth':
        return '12th'
      case 'puc':
        return 'Diploma'
      case 'p_g_diploma':
        return 'PG DIPLOMA'
      case 'diploma':
        return 'Diploma'
      case 'ug':
        return 'UG'
      case 'pg':
        return 'PG '
      case 'phd':
        return 'PD'
      case 'pd':
        return 'PD'
      default:
        break
    }
  }

  const SkillsAPI = async search => {
    try {
      const results = await searchAPI(
        searchConfig?.skills?.name,
        search,
        searchConfig?.skills
      )
      let updatedSkills = results || []
      const newSkill = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }
      if (updatedSkills.length === 0 && search) {
        setListOfAddedSkills(prev => [...prev, newSkill])
        updatedSkills = [newSkill, ...updatedSkills]
      }

      const isExactMatch = updatedSkills.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills(prev => [...prev, newSkill])
          updatedSkills = [newSkill, ...updatedSkills]
        } else {
          updatedSkills = updatedSkills
        }
      }

      if (!allSkills?.length) {
        setAllSkills(updatedSkills)
      }
      setSkillLoading(false)
      return updatedSkills
    } catch (error) {
      setSkillLoading(false)
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        await SkillsAPI('')
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])
  
  useEffect(() => {
    getListOfState('', '', false, setLoadingState)
    
    searchAPI(
      searchConfig?.universities?.name,
      '',
      searchConfig?.universities
    )
    .then(results => setUniversitySearchList(results))
    .catch(error =>
      console.error(
        `Error searching ${searchConfig?.universities?.name}:`,
        error
      )
    )
  }, [])

  useEffect(() => {
    dispatch(getAppliedRoleMetrics())
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    let config = tpoConfig
    if (!config || !config.tpoApprovalConfig || !config.tpoApprovalConfig.fields || !config.isRequestForTPOApproval) {
      setFrozenFieldsMap({})
      return
    }

    const frozen = {}
    const educationData = studentFormData?.education || []
    const fields = config.tpoApprovalConfig.fields
    
    const addNewConfig = fields['education.addNew']
    const shouldFreezeAddNew = (addNewConfig?.freezeAfterVerification || addNewConfig?.freezeAfterApproval) && educationData.length >= 1
    setIsAddNewFrozen(shouldFreezeAddNew)

    educationData.forEach((edu) => {
      if (!edu.id) return

      const eduId = edu.id
      frozen[eduId] = {}

      let fieldPrefix = ''
      const level = edu.educationLevel?.toLowerCase()
      
      if (level === 'tenth' || level === 'hsc') {
        fieldPrefix = 'tenth'
      } else if (level === 'twelfth' || level === 'sslc' || level === 'puc') {
        fieldPrefix = 'twelfth'
      } else if (level?.startsWith('ug') || level?.startsWith('pg') || level?.startsWith('diploma') || level?.startsWith('p_g_diploma') || level?.startsWith('phd') || level?.startsWith('pd')) {
        const isCurrentCourse = studentFormData?.currentCourse?.id === edu.id
        fieldPrefix = isCurrentCourse ? 'currentCourse' : 'otherEducation'
      }

      if (!fieldPrefix) {
        return
      }

      let eduFields = []
      if (fieldPrefix === 'tenth' || fieldPrefix === 'twelfth') {
        eduFields = ['board', 'endedYear', 'marks', 'markSheetUrl']
      } else {
        eduFields = ['state', 'city', 'collegeName', 'university', 'degree', 'department', 'specialisation', 'endedYear', 'marks', 'markSheetUrl']
        if (fieldPrefix === 'currentCourse') {
          eduFields.push('noOfArrears')
        }
      }

      eduFields.forEach((field) => {
        const fullFieldName = `${fieldPrefix}.${field}`
        const fieldConfig = fields[fullFieldName]

        if (fieldConfig && (fieldConfig.freezeAfterApproval || fieldConfig.freezeAfterVerification)) {
          let fieldValue = edu[field]
          
          // For currentCourse, use averageMarks instead of marks
          // Don't use averageMarks if it's 0 or "0" (0 marks should not be frozen)
          if (field === 'marks' && !fieldValue && edu.averageMarks && parseFloat(edu.averageMarks) !== 0) {
            fieldValue = edu.averageMarks
          }
          if (field === 'endedYear' && !fieldValue && edu.endedOn) {
            fieldValue = moment(parseInt(edu.endedOn)).format('YYYY')
          }
          if (field === 'collegeName' && !fieldValue && edu.institutionName) {
            fieldValue = edu.institutionName
          }
          if (field === 'specialisation' && !fieldValue && edu.specialisation) {
            fieldValue = edu.specialisation
          }
          if (field === 'department' && !fieldValue && edu.department) {
            fieldValue = edu.department
          }
          
          // For markSheetUrl field, freeze based on TPO config alone (no value check needed)
          // For other fields, only freeze if they have values
          if (field === 'markSheetUrl') {
            frozen[eduId][field] = true
            // Also add the full TPO config field name for EducationFormPartial compatibility
            frozen[eduId][`${fieldPrefix}.${field}`] = true
          } else {
            // For noOfArrears, treat 0 as empty (no arrears = no value)
            const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                             (!Array.isArray(fieldValue) || fieldValue.length > 0) &&
                             !(field === 'noOfArrears' && fieldValue === 0)

            if (hasValue) {
              frozen[eduId][field] = true
              // Also add the full TPO config field name for EducationFormPartial compatibility
              frozen[eduId][`${fieldPrefix}.${field}`] = true
              if (field === 'state' && !frozen[eduId]['stateId']) {
                frozen[eduId]['stateId'] = true
                frozen[eduId][`${fieldPrefix}.stateId`] = true
              }
              if (field === 'city' && !frozen[eduId]['cityId']) {
                frozen[eduId]['cityId'] = true
                frozen[eduId][`${fieldPrefix}.cityId`] = true
              }
              if (field === 'collegeName' && !frozen[eduId]['collegeId'] && !frozen[eduId]['institutionId']) {
                frozen[eduId]['collegeId'] = true
                frozen[eduId]['institutionId'] = true
                frozen[eduId][`${fieldPrefix}.collegeId`] = true
                frozen[eduId][`${fieldPrefix}.institutionId`] = true
              }
              if (field === 'university' && !frozen[eduId]['universityId']) {
                frozen[eduId]['universityId'] = true
                frozen[eduId][`${fieldPrefix}.universityId`] = true
              }
              if (field === 'degree' && !frozen[eduId]['degreeId']) {
                frozen[eduId]['degreeId'] = true
                frozen[eduId][`${fieldPrefix}.degreeId`] = true
              }
              if (field === 'department' && !frozen[eduId]['streamId']) {
                frozen[eduId]['streamId'] = true
                frozen[eduId][`${fieldPrefix}.streamId`] = true
              }
              if (field === 'specialisation' && !frozen[eduId]['specialisationId']) {
                frozen[eduId]['specialisationId'] = true
                frozen[eduId][`${fieldPrefix}.specialisationId`] = true
              }
            }
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.education, studentFormData?.currentCourse])

  useEffect(() => {
    setLocalLoading(true)
    
    // Merge pending education data (educationList includes current course)
    const approvedEducation = educationList || []
    const pendingEducation = pendingData?.education || []
    
    // Also check for pending current course
    const pendingCurrentCourse = pendingData?.currentCourse
    if (pendingCurrentCourse) {
      pendingEducation.push(pendingCurrentCourse)
    }
    
    const pendingMap = new Map()
    pendingEducation.forEach(e => {
      if (e.id && !e.id.startsWith('temp-')) {
        pendingMap.set(e.id, e)
      }
    })
    
    const mergedEducation = approvedEducation.map(approvedEdu => {
      const pendingEdu = pendingMap.get(approvedEdu.id)
      
      if (pendingEdu && pendingEdu._pendingFields) {
        const merged = { ...approvedEdu }
        
        let requestId = null
        const firstFieldKey = Object.keys(pendingEdu._pendingFields)[0]
        if (firstFieldKey && pendingEdu._pendingFields[firstFieldKey]._requestId) {
          requestId = pendingEdu._pendingFields[firstFieldKey]._requestId
        }
        
        Object.keys(pendingEdu._pendingFields).forEach(fieldName => {
          merged[fieldName] = pendingEdu._pendingFields[fieldName].value
        })
        
        merged._pendingFields = pendingEdu._pendingFields
        merged._requestId = requestId
        merged._hasPendingChanges = true
        
        return merged
      }
      
      return approvedEdu
    })
    
    const newPendingEducation = pendingEducation.filter(e => 
      e._isNew || (e.id && e.id.startsWith('temp-'))
    )
    
    const allMergedEducation = [...mergedEducation, ...newPendingEducation]
    
    let educationsdataList = []
    allMergedEducation?.map(data => {
      let type =
        data?.educationLevel === 'tenth' || data?.educationLevel === 'twelfth'
    
    const pendingEducationMap = pendingMap

      let level = getEducationLevelValue(
        data?.educationLevel,
        true,
        educationsdataList
      )

      const getPendingValue = (fieldName, defaultValue) => {
        const pendingEdu = pendingEducationMap.get(data?.id)
        if (pendingEdu && pendingEdu._pendingFields && pendingEdu._pendingFields[fieldName]) {
          return pendingEdu._pendingFields[fieldName].value
        }
        return defaultValue
      }

      form.setFieldsValue({
        [level]: {
          id: data?.id,
          temp_id: data?.temp_id,
          educationLevel: level,
          university: getPendingValue('university', data?.university),
          universityId: getPendingValue('universityId', data?.universityId),
          institutionName: getPendingValue('institutionName', data?.institutionName),
          collegeName: getPendingValue('collegeName', data?.collegeName),
          institutionId: getPendingValue('institutionId', data?.institutionId),
          collegeId: getPendingValue('collegeId', data?.collegeId),
          board: getPendingValue('board', data?.board),
          degree: getPendingValue('degree', data?.degree),
          department: getPendingValue('department', data?.department),
          specialisation: getPendingValue('specialisation', data?.specialisation),
          degreeStreamMapId: getPendingValue('degreeStreamMapId', data?.degreeStreamMapId),
          degreeId: getPendingValue('degreeId', data?.degreeId),
          specialisationId: getPendingValue('specialisationId', data?.specialisationId),
          streamId: getPendingValue('streamId', data?.streamId),
          startedOn:
            getPendingValue('startedOn', data?.startedOn) > 0
              ? moment(parseInt(getPendingValue('startedOn', data?.startedOn))).format('MM/YYYY')
              : null,
          endedOn:
            getPendingValue('endedOn', data?.endedOn) > 0
              ? moment(parseInt(getPendingValue('endedOn', data?.endedOn))).format('MM/YYYY')
              : null,
           endedYear:
                      getPendingValue('endedOn', data?.endedOn) > 0
                        ? moment(parseInt(getPendingValue('endedOn', data?.endedOn))).format('YYYY')
                        : null,    
          marks: data?.marks ? parseFloat(data?.marks).toFixed(2) : null,
          averageMarks: data?.averageMarks ? parseFloat(data?.averageMarks).toFixed(2) : null,
          noOfArrears: data?.noOfArrears,
          historyOfArrears: data?.historyOfArrears,
          state: data?.state,
          stateId: data?.stateId,
          city: data?.city,
          cityId: data?.cityId,
          tcUrl: data?.tcUrl,
          markSheetUrl: data?.markSheetUrl,
          awards: data?.awards,
          skills: data?.skills,
          domain: data?.domain,
          domainId: data?.domainId,
          isDelete: false,
          shown: true,
        },
      })

    educationsdataList.push({
        id: data?.id,
        temp_id: data?.temp_id,
        component: EducationForm,
        level: level,
        label: getEducationLevelLabel(data?.educationLevel),
        type: type,
        isCurrentCourse: !!data?.isCurrentCourse,
        pendingFields: data?._pendingFields || {},
        frozenFields: frozenFieldsMap[data?.id] || {},
        _requestId: data?._requestId,
        _hasPendingChanges: !!data?._hasPendingChanges
      })
    })
    setEducation(educationsdataList)

    setTimeout(() => {
      setLocalLoading(false)
    }, 500)
  }, [educationList, frozenFieldsMap, pendingData])

  const subjectHandler = (educationLevel, option) => {
    setIsUpdateButtonEnabled(false)
    setRefreshKey(refreshKey + 1)
    let arr = []
    let type = option?.value === 'tenth' || option?.value === 'twelfth'
    arr.push({
      component: EducationForm,
      level: option?.value,
      label: option?.label,
      type: type,
      pendingFields: {},
      frozenFields: {},
      _requestId: null
    })
    let levelsList = education?.map(data => data?.level)
    if (educationLevel !== true && !levelsList.includes(educationLevel))
      return setEducation(edu => edu.concat(arr))
  }

  const getEducationLevelValue = (value, isUpdate = false, educationsList) => {
    if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      let list = (isUpdate ? educationsList : education)?.filter(data =>
        data?.level?.includes(value)
      )
      if (value === 'ug') {
        return 'ug' + '_' + list?.length
      } else if (value === 'diploma') {
        return 'diploma' + '_' + list?.length
      } else if (value === 'pg') {
        return 'pg' + '_' + list?.length
      } else if (value === 'phd') {
        return 'phd' + '_' + list?.length
      } else if (value === 'p_g_diploma') {
        return 'p_g_diploma' + '_' + list?.length
      }
    } else {
      return value
    }
  }

  const getAddedLevel = value => {
    let levelsList = education?.map(data => data?.level)

    if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      return true
    } else {
      return levelsList.includes(value)
    }
  }

  const onRemoveEducation = async (deleteLevel, educationId) => {
    // Check if trying to delete 12th standard for UG students - but don't show error here
    if ((deleteLevel === 'twelfth' || deleteLevel === '12th') && studentFormData?.currentCourse?.educationLevel === 'ug') {
      // Allow the deletion to proceed visually, but validation will catch it on submit
      console.log('UG student attempting to delete 12th standard - will be validated on submit');
    }
    
    setIsUpdateButtonEnabled(false)
    let updatedList = education?.filter(data => data?.level !== deleteLevel)
    if (educationId) {
      SuccessMessage('Deleted successfully!')
      form.setFieldsValue({
        [deleteLevel]: '',
      })
      const newDeleteLevel = deleteLevel + 'deleted'
      form.setFieldsValue({
        [newDeleteLevel]: { id: educationId, isDelete: true },
      })
      return setEducation(updatedList)
    } else {
      return setEducation(updatedList)
    }
  }
  
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

  useEffect(() => {
    let currentCourseData = studentFormData?.currentCourse || studentFormData?.student?.currentCourse
    
    if (!currentCourseData) {
      // If no current course, just set education list without it
      if (studentFormData?.education) {
        setEducationList(studentFormData.education)
      }
      return
    }
    
    setExamType(currentCourseData?.examType)
    setDuration(currentCourseData?.duration)
    
    const pendingCurrentCourse = pendingData?.currentCourse
    let currentCourseRequestId = null
    let pendingFieldsForCurrentCourse = null
    
    if (pendingCurrentCourse) {
      if (pendingCurrentCourse._pendingFields) {
        // Handle structured format with _pendingFields
        const firstFieldKey = Object.keys(pendingCurrentCourse._pendingFields)[0]
        if (firstFieldKey && pendingCurrentCourse._pendingFields[firstFieldKey]._requestId) {
          currentCourseRequestId = pendingCurrentCourse._pendingFields[firstFieldKey]._requestId
        }
        pendingFieldsForCurrentCourse = pendingCurrentCourse._pendingFields
      } else {
        // Handle direct format where pending data is on the object itself
        const pendingFieldsMap = {}
        Object.keys(pendingCurrentCourse).forEach(fieldName => {
          // GET /students/:id/pending-data always returns a currentCourse scaffold of
          // six explicit nulls (averageMarks, noOfArrears, historyOfArrears,
          // university, specialisation, marks) whether or not anything is actually
          // awaiting approval. Accepting null here minted a pending entry for each of
          // them — and a 'pending' _requestId — so every student saw the verification
          // icon on those fields. A null is the absence of a pending change.
          if (fieldName !== 'id' && fieldName !== 'isCurrentCourse' && pendingCurrentCourse[fieldName] !== undefined && pendingCurrentCourse[fieldName] !== null) {
            let fieldValue = pendingCurrentCourse[fieldName]
            
            // Handle nested specialisation object
            if (fieldName === 'specialisation' && typeof fieldValue === 'object' && fieldValue !== null) {
              if (fieldValue.specialisation) {
                pendingFieldsMap.specialisation = { value: fieldValue.specialisation }
                if (fieldValue.specialisationId) {
                  pendingFieldsMap.specialisationId = { value: fieldValue.specialisationId }
                }
              }
            } else {
              pendingFieldsMap[fieldName] = { value: fieldValue }
            }
          }
        })
        if (Object.keys(pendingFieldsMap).length > 0) {
          pendingFieldsForCurrentCourse = pendingFieldsMap
          currentCourseRequestId = 'pending'
        }
      }
    }
    
    let currentCourse = {
      id: currentCourseData?.id,
      isCurrentCourse: true,
      university: currentCourseData?.university,
      universityId: currentCourseData?.universityId,
      educationLevel: currentCourseData?.educationLevel,
      collegeName: studentFormData?.student?.instituteCampusName,
      collegeId: studentFormData?.student?.instituteCampusId,
      board: '',
      degree: currentCourseData?.degree,
      department: currentCourseData?.department,
      specialisation: currentCourseData?.specialisation,
      degreeStreamMapId: currentCourseData?.degreeStreamMapId,
      startedOn: currentCourseData?.startedOn,
      endedOn: currentCourseData?.endedOn,
      skills: currentCourseData?.skills,
      degreeId: currentCourseData?.degreeId,
      streamId: currentCourseData?.streamId,
      specialisationId: currentCourseData?.specialisationId,
      averageMarks: currentCourseData?.averageMarks
        ? currentCourseData?.averageMarks
        : 0,
      marks: currentCourseData?.averageMarks ? currentCourseData?.averageMarks : 0,
      state: currentCourseData?.state || '',
      stateId: currentCourseData?.stateId || '',
      city: currentCourseData?.city || '',
      cityId: currentCourseData?.cityId || '',
      noOfArrears: currentCourseData?.noOfArrears ?? 0,
      historyOfArrears: currentCourseData?.historyOfArrears ?? 0,
      domain: currentCourseData?.domain,
      domainId: currentCourseData?.domainId,
      _requestId: currentCourseRequestId,
      _pendingFields: pendingFieldsForCurrentCourse,
    }
    
    // Merge pending values into currentCourse
    if (pendingFieldsForCurrentCourse) {
      // First pass: merge all non-null values
      Object.keys(pendingFieldsForCurrentCourse).forEach(fieldName => {
        const pendingValue = pendingFieldsForCurrentCourse[fieldName].value
        if (pendingValue !== null) {
          currentCourse[fieldName] = pendingValue
        }
      })
      
      // Second pass: sync marks and averageMarks
      if (pendingFieldsForCurrentCourse.averageMarks?.value !== null && pendingFieldsForCurrentCourse.averageMarks?.value !== undefined) {
        currentCourse.marks = pendingFieldsForCurrentCourse.averageMarks.value
        currentCourse.averageMarks = pendingFieldsForCurrentCourse.averageMarks.value
      } else if (pendingFieldsForCurrentCourse.marks?.value !== null && pendingFieldsForCurrentCourse.marks?.value !== undefined) {
        currentCourse.averageMarks = pendingFieldsForCurrentCourse.marks.value
        currentCourse.marks = pendingFieldsForCurrentCourse.marks.value
      }
    }
    if (!studentFormData?.student?.isExpCandidate) {
      let educationList =
        studentFormData?.education?.length > 0
          ? [...(studentFormData?.education || []), currentCourse]
          : [currentCourse]
      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)
    } else if (studentFormData?.student?.isExpCandidate) {
      let educationList = studentFormData?.education
      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)
    }
  }, [studentFormData, instituteName, pendingData])

  const getEducationLevel = level => {
    let name = level?.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }

  const getEducationLevelSearch = level => {
    let name = level?.replaceAll('_', '')
    let result = name?.replace(/\d/g, '')
    return result === 'pgdiploma'
      ? 'P_G_DIPLOMA'
      : result === 'pd'
      ? 'PHD'
      : result?.toUpperCase()
  }

  const getEducationLevel1 = level => {
    let name = level?.replaceAll('_', '')
    return name === 'pgdiploma'
      ? 'p_g_diploma'
      : name?.replace(/\d/g, '')?.toLowerCase()
  }

  const checkMandatory = (twelth, diploma) => {
    return twelth === true || diploma === true
  }

  const submitHandler = async () => {
    let values = await form.getFieldValue()
    const errorList = []
    await form
      .validateFields()
      .then(res => {
        setSubmitLoading(true)
      })
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    if (!errorList?.length) {
      let tenth = false
      let twelth = false
      let diploma = false
      let under = false
      let educationList = []
      let educationDeleteList = []
      let currentCourse = []
      const convertedData = Object.keys(values).reduce((acc, key) => {
        if (
          key.includes('ug_') ||
          key.includes('pg_') ||
          key.includes('diploma_') ||
          key.includes('phd_') ||
          key.includes('p_g_diploma')
        ) {
          const [name, award] = key.split('award+')
          const value = values[key]
          if (!acc[name]) {
            acc[name] = {
              ...value,
              awards: [],
            }
          }
          if (key.includes('award+')) acc[name].awards.push({ ...value })
        } else {
          acc[key] = values[key]
        }
        return acc
      }, {})
      // First, check all form values to properly set validation flags
      Object.values(convertedData)?.forEach(data => {
        if (data?.educationLevel && !data?.isDelete) {
          const level = getEducationLevel1(data?.educationLevel)?.toLowerCase()
          if (level === 'tenth') tenth = true
          if (level === 'twelfth' || level === 'sslc') twelth = true
          if (level === 'diploma' || level === 'puc') diploma = true
        }
      })

      // Also check existing education data from studentFormData to ensure we don't miss any
      studentFormData?.education?.forEach(data => {
        const level = data?.educationLevel?.toLowerCase()
        if (level === 'tenth') tenth = true
        if (level === 'twelfth' || level === 'sslc') twelth = true
        if (level === 'diploma' || level === 'puc') diploma = true
      })

      // Check current course education level as well
      if (studentFormData?.currentCourse?.educationLevel) {
        const currentLevel = studentFormData.currentCourse.educationLevel.toLowerCase()
        if (currentLevel === 'diploma' || currentLevel === 'puc') diploma = true
      }

      Object.values(convertedData)?.forEach(data => {
           if (data?.isDelete) {
             educationDeleteList.push(data?.id)
           } else if (data?.noOfArrears >= 0) {
            
            currentCourse.push({
              ...data,
              averageMarks: data?.marks,
              endedOn: studentFormData?.currentCourse?.endedOn,
              skills:
              data?.skills?.filter(skill => skill != null)?.map(skill => ({
                id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                  skill.id
                )
                  ? skill.id
                  : '',
                name: skill.name,
              })) || [],
              university: data?.university || null,
              historyOfArrears: data?.historyOfArrears || 0,
          })
           } else if (data?.marks && !data?.noOfArrears) {
           
             const educationItem = {
               ...data,
               state: data?.state || '',
               stateId: data?.stateId || '',
               city: data?.city || '',
               cityId: data?.cityId || '',
               educationLevel: getEducationLevel1(data?.educationLevel),
               endedOn: data?.endedYear
                 ? moment(data?.endedYear, 'YYYY').format('x')
                 : null,
               skills:
                 data?.skills?.filter(skill => skill != null)?.map(skill => ({
                   id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                     skill.id
                   )
                     ? skill.id
                     : '',
                   name: skill.name,
                 })) || [],
               tcUrl: data?.tcUrl || {},
               markSheetUrl: data?.markSheetUrl || {},
               university: data?.university || null,
               historyOfArrears: data?.historyOfArrears || 0,
             }
   
             educationList.push(educationItem)
           }
         })

      // Check if UG students have either 12th standard OR diploma education
      console.log('=== EDUCATION UPDATE VALIDATION (MODAL) ===');
      console.log('Current course education level:', studentFormData?.currentCourse?.educationLevel);
      console.log('Education delete list:', educationDeleteList);
      console.log('Twelfth flag:', twelth);
      console.log('Diploma flag:', diploma);
      
      if (studentFormData?.currentCourse?.educationLevel === 'ug') {
        // Check if 12th standard is being deleted
        const deletingTwelfth = educationDeleteList.some(deleteId => {
          const educationToDelete = studentFormData?.education?.find(edu => edu.id === deleteId);
          return educationToDelete?.educationLevel === 'twelfth';
        });
        
        // Check if diploma is being deleted
        const deletingDiploma = educationDeleteList.some(deleteId => {
          const educationToDelete = studentFormData?.education?.find(edu => edu.id === deleteId);
          return educationToDelete?.educationLevel === 'diploma' || educationToDelete?.educationLevel === 'puc';
        });
        
        console.log('Deleting twelfth:', deletingTwelfth);
        console.log('Deleting diploma:', deletingDiploma);
        
        // Check if user will have either 12th OR diploma after deletion
        const willHaveTwelfth = twelth && !deletingTwelfth;
        const willHaveDiploma = diploma && !deletingDiploma;
        
        console.log('Will have twelfth after deletion:', willHaveTwelfth);
        console.log('Will have diploma after deletion:', willHaveDiploma);
        
        // Error only if BOTH 12th and diploma are missing/deleted
        if (!willHaveTwelfth && !willHaveDiploma) {
          ErrorMessage('UG students must have either 12th standard or Diploma education. At least one is mandatory.');
          setSubmitLoading(false);
          return;
        }
      }

      // Format DOB properly to avoid validation errors
      const formatDOB = (dob) => {
        if (!dob) return undefined
        if (moment(dob, moment.ISO_8601, true).isValid()) {
          return moment(dob).format('YYYY-MM-DD')
        }
        if (moment(dob, 'YYYY-MM-DD', true).isValid()) {
          return dob
        }
        return moment(dob).format('YYYY-MM-DD')
      }

      let payload = {
        refreshRanking: true,
        checkForApproval: true,
        checkDeleteSection: ['education'],
        admin: {
          ...studentFormData?.admin,
          dob: formatDOB(studentFormData?.admin?.dob),
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: {
          ...studentFormData?.student,
        },
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? { ...studentFormData?.currentCourse, 
            noOfArrears: currentCourse[0]?.noOfArrears, 
            specialisationId: currentCourse[0]?.specialisationId,
            averageMarks: currentCourse[0]?.averageMarks,
            endedOn: currentCourse[0]?.endedOn,
            skills: currentCourse[0]?.skills,
            university: currentCourse[0]?.university,
            universityId: currentCourse[0]?.universityId,
            historyOfArrears: currentCourse[0]?.historyOfArrears,
           }
          : {},
        education: (() => {
          const uniqueEducation = []
          const seen = new Set()

          educationList.forEach(edu => {
            const key = JSON.stringify({
              educationLevel: edu.educationLevel,
              degree: edu.degree,
              institutionName: edu.institutionName,
              endedOn: edu.endedOn,
              marks: edu.marks,
            })

            if (!seen.has(key)) {
              seen.add(key)

              const {
                _pendingFields,
                _requestId,
                _isNew,
                _status,
                shown,
                ...cleanEdu
              } = edu

              uniqueEducation.push(cleanEdu)
            }
          })

          return uniqueEducation
        })(),
        resume: studentFormData?.resume,
        degreeStreamMap:
        !studentFormData?.student?.isExpCandidate &&
        studentFormData?.currentCourse?.degreeId &&
        studentFormData?.currentCourse?.streamId
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        checkForApproval: true,
        checkDeleteSection: ['education'],
      }
      delete payload?.currentCourse?.startMonth
      delete payload?.currentCourse?.startYear
      delete payload?.currentCourse?.endMonth
      delete payload?.currentCourse?.endYear

      payload?.education.map((item, index) => {
        delete payload?.education[index]?.startMonth
        delete payload?.education[index]?.startYear
        delete payload?.education[index]?.endMonth
        // delete payload?.education[index]?.endYear

        return null
      })

      if (payload?.currentCourse?.specialisationId === null) {
        //delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }

      payload?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
        return null
      })

      // Additional validation check for current course
      currentCourse?.forEach((value) => {
        const level = value?.educationLevel?.toLowerCase()
        if (level === 'diploma' || level === 'puc') {
          diploma = true
        }
        if (level === 'ug') {
          under = true
        }
      })
      if (!payload?.currentCourse?.noOfArrears) {
        payload.currentCourse.noOfArrears = 0
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }

      if (tenth && checkMandatory(twelth, diploma)) {
        let response = await updateStudentData(payload)

        const data = response?.response?.data

        if (
          data?.student?.currentState != 4 &&
          data?.student?.educationProfile?.length > 0 &&
          (data?.isAnywhere || data?.preferredJobLocation?.length > 0)
        ) {
        //  await dispatch(updateCurrentState(data?.student?.id, 4))
        }
        setUpdated(true)
        if (response?.success === true) {
          if (educationDeleteList?.length > 0) {
            educationDeleteList.map(async item => {
              await deleteEducation(item)
            })
          }
          SuccessMessage('Education details saved successfully!')
          await dispatch(setResumeData(payload))
          await dispatch(getStudentData())
          if (getPendingData) {
            await getPendingData()
          }
          setModalVisible(false)
          setSubmitLoading(false)
          // After successful update, fetch new eligibility details if needed
          if (setExpDrawer) {
            setExpDrawer(true)
          }
          if (roleDrawer) setRoleDrawer(true)
          if (getEligibleDetails) {
            getEligibleDetails({ roleID: itemId, setLoading })
          }
          if (getRoleFloatDetails) {
            getRoleFloatDetails({ setLoading })
          }
        } else {
          setSubmitLoading(false)
          ErrorMessage(response?.response?.data?.message)
        }
      } else if (!tenth && checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('10th is Mandatory')
      } else if (tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('12th or Diploma is Mandatory')
      } else if (!tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('10th  And 12th  or Diploma is Mandatory')
      }
    } else {
      const errorForms = []
      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  const modalContent = () => {
    return (
      <>
        {!loading && !skillLoading && (
          <Form
            scrollToFirstError
            htmlType="submit"
            onFinish={submitHandler && !updated}
            id={'educationForm'}
            form={form}
            layout="vertical"
          >
            {education.length
              ? education.map((type, index) => {
                  return (
                    <type.component
                      form={form}
                      key={index + 'type'}
                      level={type?.level}
                      label={type?.label}
                      isType={type?.type}
                      universitySearchList={universitySearchList}
                      setUniversitySearchList={setUniversitySearchList}
                      onRemoveEducation={onRemoveEducation}
                      isCurrentCourse={type?.isCurrentCourse}
                      studentFormData={studentFormData}
                      getEducationLevel={getEducationLevel}
                      educationId={type?.id}
                      countryId={countryId}
                      setCountryId={setCountryId}
                      countryList={countryList}
                      setUniversityName={setUniversityName}
                      universityValue={universityName}
                      universityList={universityList}
                      stateList={stateList}
                      setStateId={setStateId}
                      stateId={stateId}
                      cityId={cityId}
                      setCityId={setCityId}
                      setLocationData={setLocationData}
                      locationData={locationData}
                      getListOfCountries={getListOfCountries}
                      getListOfState={getListOfState}
                      getListOfCity={getListOfCity}
                      examType={examType}
                      duration={duration}
                      setExamType={setExamType}
                      setDuration={setDuration}
                      listOfStudentSkills={listOfStudentSkills}
                      instituteCampusValue={instituteCampusName}
                      setInstituteCampusName={setInstituteCampusName}
                      AllCollegeList={AllCollegeList}
                      CollegeList={CollegeList}
                      universityId={universityId}
                      setUniversityId={setUniversityId}
                      setInstituteId={setInstituteId}
                      insttituteId={instituteId}
                      getListOfSkills={getListOfSkills}
                      setCurrentInstituteName={setCurrentInstituteName}
                      setCurrentInstituteId={setCurrentInstituteId}
                      currentInstituteId={currentInstituteId}
                      currentInstituteName={currentInstituteName}
                      setSearchCollege={setSearchCollege}
                      searchCollege={searchCollege}
                      setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                      setLoadingState={setLoadingState}
                      setLoadingCity={setLoadingCity}
                      loadingCity={loadingCity}
                      loadingState={loadingState}
                      getEducationLevelSearch={getEducationLevelSearch}
                      skillLoading={skillLoading}
                      setSkillLoading={setSkillLoading}
                      setListOfSkills={setListOfSkills}
                      listOfSkills={listOfSkills}
                      SkillsAPI={SkillsAPI}
                      shown={shown}
                      searchAPI={searchAPI}
                      allSkills={allSkills}
                      pendingFields={type.pendingFields}
                      frozenFields={type.frozenFields}
                      _requestId={type._requestId}
                    />
                  )
                })
              : null}
            {skillLoading && <Spin />}
            <LocalDiv>
              <Control alignCenter gap="10px">
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>   {education?.some(item => 
                  (item?.level === 'twelfth' || item?.label === 'Diploma')
                ) 
                  ? "Add Education" 
                  : "12th or Diploma *"}</Text>
              </Control>
            </LocalDiv>

            <SelectLocalWrapper
              key={refreshKey}
              onChange={(e, option) => !isAddNewFrozen && subjectHandler(e, option)}
              disabled={isAddNewFrozen}
              style={{ 
                opacity: isAddNewFrozen ? 0.5 : 1, 
                cursor: isAddNewFrozen ? 'not-allowed' : 'pointer' 
              }}
            >
               {education?.some(item => 
                                                                       (item?.level === 'twelfth' || item?.label === 'Diploma')
                                                    ) 
                                                      ? educationDetails?.map((data, index) => {
                                                          let valueData = getEducationLevelValue(data?.value, false, [])
                                                          return (
                                                            <Option
                                                              value={valueData}
                                                              key={index + 'data'}
                                                              label={getEducationLevelLabel(data?.value)}
                                                            >
                                                              <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                                                                {data?.label}
                                                              </OptionWrapper>
                                                            </Option>
                                                          )
                                                        })
                                                      : educationDetailsBefore?.map((data, index) => {
                                                          let valueData = getEducationLevelValue(data?.value, false, [])
                                                          return (
                                                            <Option
                                                              value={valueData}
                                                              key={index + 'data'}
                                                              label={getEducationLevelLabel(data?.value)}
                                                            >
                                                              <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                                                                {data?.label}
                                                              </OptionWrapper>
                                                            </Option>
                                                          )
                                                        })
                                                    }
            </SelectLocalWrapper>
          </Form>
        )}
        {loading && <Spin />}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setModalVisible(false)
            setSubmitLoading(false)
          }}
        />
        <Button.Primary
          form={'educationForm'}
          htmlType="submit"
          onClick={submitHandler}
          text={'Update'}
          disabled={submitLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <Modal
      visible={modalVisible}
      onCancel={() => setModalVisible(false)}
      centered
      width="82%"
      footer={footer()}
      maskClosable={false}
      closable={false}
      destroyOnClose={true}
      bodyStyle={{
        padding: '0',
        borderRadius: '10px',
        height: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            padding: '15px 30px',
            overflowY: 'auto',
            alignSelf: 'stretch',
          }}
        >
          <FlexWrapRole spaceBetween>
            <div
              style={{
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '25px',
                color: '#343E59',
              }}
            >
              {education?.length === 0
                ? 'Add Educational Details'
                : 'Update Educational Details'}
            </div>
            <StyledDiv onClick={() => setModalVisible(false)}>
              <CrossIconSkill />
            </StyledDiv>
          </FlexWrapRole>
          {modalContent()}
        </div>
      </div>
    </Modal>
  )
}
export default EducationalModal;
